var map = {
	"./bank.svg": 53349,
	"./binance.svg": 11115,
	"./binanceus.svg": 35847,
	"./bitstamp.svg": 94277,
	"./coinbase-white.svg": 19059,
	"./coinbase.svg": 44147,
	"./coinbaseWallet.svg": 27448,
	"./crypto-wallet.svg": 11150,
	"./gemini.svg": 99978,
	"./kraken.svg": 96033,
	"./metaMask.svg": 59600,
	"./okcoin-white.svg": 10778,
	"./okcoin.svg": 68782,
	"./walletConnect.svg": 73246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24077;